import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { IECI } from "../../models/ECI";
import { Dialog } from "primereact/dialog";
import { format } from "date-fns";
import { ILogin } from "../../models/Login";
import { safeFormatDate } from "../../models/DateFormatMapper";

interface Iprops {
    singleData: IECI,
    open: boolean,
    hideDialog: () => void,
    toast: any
}

export const TableHistory = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IECI>, loading: boolean });

    let _role: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _role.push(role.role_ID);
    });

    useEffect(() => {
        if (props.singleData.ecI_ID) loadTableData();
    }, [props.singleData]);

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("ECI/history", "GET", null, `ecI_ID=${props.singleData.ecI_ID}`, props.toast);
        if (response) {
            const data: Array<IECI> = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const salesmanager = () => {
        return (<>{props.singleData.salesmanager}</>);
    };
    const user_Name = () => {
        return (<>{props.singleData.user_Name}</>);
    };
    const consultant_Name = () => {
        return (<>{props.singleData.consultant_Name}</>);
    };
    const thirdparty = () => {
        return (<>{props.singleData.thirdparty}</>);
    };
    const vendor_Company_Name = () => {
        return (<>{props.singleData.vendor_Company_Name}</>);
    };
    const ecI_Client = () => {
        return (<>{props.singleData.ecI_Client}</>);
    };
    const eciDate = (rowData: IECI) => {
        let date;
        if (rowData.eciDate) date = format(new Date(rowData.eciDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const onHide = () => {
        props.hideDialog();
        setTableData({ tableData: [], loading: false });
    }

    const DateFormat = loginObj.date_Format;
    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header={`ECI History found against ReqID - ${props.singleData.req_ID} (${props.singleData.req_Job_Title})`} modal className="p-fluid" onHide={onHide}>
            <DataTable size="small" stripedRows
                value={tableData.tableData}
                loading={tableData.loading}
            >
                <Column field="salesmanager" header="Sales Manager" body={salesmanager} />
                <Column field="user_Name" header="Recruiter" body={user_Name} />
                <Column field="consultant_Name" header="Consultant Name" body={consultant_Name} />
                <Column field="thirdparty" header="Third Party" body={thirdparty} />
                {!(_role.includes(3) || _role.includes(4) || _role.includes(21)) && <Column field="vendor_Company_Name" header="Prime Vendor" body={vendor_Company_Name} />}
                {!(_role.includes(3) || _role.includes(4) || _role.includes(21)) && <Column field="ecI_Client" header="Client" body={ecI_Client} />}
                {/* <Column field="eciDate" header="Int. Date" body={eciDate} /> */}
                <Column field="eciDate" header="Int. Date" body={(rowData: any)=> safeFormatDate(rowData.eciDate, "dd/MM/yyyy", DateFormat)} />
                <Column field="ecI_Time" header="Int. Time" />
                <Column field="time_Zone_Name" header="Zone" />
                <Column field="ecI_Type_Name" header="Status" />
                <Column field="comments" header="Comments" />
            </DataTable>
        </Dialog>
    );
}
